var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-radio',_vm._g({attrs:{"val":_vm.val,"value":_vm.value,"label":_vm.label,"disable":_vm.disable,"size":_vm.size,"dense":_vm.dense,"color":_vm.color,"keep-color":_vm.keepColor}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }